import { isUrlParamEquals } from '../url';
export default () => isUrlParamEquals('showkeys', 'true');
//# sourceMappingURL=showCopyKeys.js.map